import SjQuestionRichText from './src/SjQuestionRichText.vue'

export default SjQuestionRichText



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-rich-text/index.js